(function () {
    var truncater = {
        $target: $('.js--truncate'),

        init: function () {
            truncater.truncate();
        },

        truncate: function () {
            truncater.$target.each(function () {
                $(this).truncate();
            });
        },
    };

    UX.truncater = truncater;
})();
